import React from 'react';
import {
  Box,
  Column,
  Row,
  SkeletonLoader,
  SkeletonLoaderVariants,
} from '@chargify/custom-ui-components';

type Props = {
  variant: SkeletonLoaderVariants;
};

const ComponentLoadingSkeleton = ({ variant }: Props) => (
  <>
    <Box marginBottom={[3, 3, 7]}>
      <Row rowGap={[8, 8, 16]}>
        <Column span={[24, 7]}>
          <SkeletonLoader height={20} width={80} variant={variant} />
        </Column>
        <Column span={[24, 17]}>
          <Box marginBottom={2}>
            <SkeletonLoader height={48} variant={variant} />
          </Box>
          <SkeletonLoader height={48} variant={variant} />
        </Column>
      </Row>
    </Box>
    <Row rowGap={[8, 8, 16]}>
      <Column span={[24, 7]}>
        <SkeletonLoader height={20} width={60} variant={variant} />
      </Column>
      <Column span={[24, 17]}>
        <Box marginBottom={2}>
          <SkeletonLoader height={150} variant={variant} />
        </Box>
        <SkeletonLoader height={150} variant={variant} />
      </Column>
    </Row>
  </>
);

export default ComponentLoadingSkeleton;
